import axios from "axios";
import apiClient from "../helper/apiClient";
import config from "../config/config";
import { API_TIMEOUT } from "../assets/constants";

export async function getExternalAccessTokenAPI(requestObject) {
  try {
    const { data } = await apiClient.get("api/getExternalAccessToken", {
      params: requestObject,
    });
    return data?.data;
  } catch (err) {
    throw new Error(err.message || err);
  }
}

export async function validateExternalAccessTokenAPI(requestObject) {
  try {
    const { data } = await apiClient.get("api/validateExternalAccessToken", {
      params: requestObject,
    });
    return data?.data;
  } catch (err) {
    throw new Error(err.message || err);
  }
}

export async function getUserSessionAPI() {
  try {
    if (!config.API_GET_USER_SESSION) {
      throw new Error("API_GET_USER_SESSION not configured");
    }
    const { data } = await axios.get(config.API_GET_USER_SESSION, {
      timeout: API_TIMEOUT,
      withCredentials: true,
    });
    return data;
  } catch (err) {
    throw new Error(err.message || err);
  }
}

export async function extendUserSessionAPI() {
  try {
    if (!config.API_EXTEND_SESSION) {
      throw new Error("API_EXTEND_SESSION not configured");
    }
    const { data } = await axios.get(config.API_EXTEND_SESSION, {
      timeout: API_TIMEOUT,
      withCredentials: true,
    });
    return data;
  } catch (err) {
    throw new Error(err.message || err);
  }
}

export async function endUserSessionAPI() {
  try {
    if (!config.API_END_SESSION) {
      throw new Error("API_END_SESSION not configured");
    }
    const { data } = await axios.get(config.API_END_SESSION, {
      timeout: API_TIMEOUT,
      withCredentials: true,
    });
    return data;
  } catch (err) {
    throw new Error(err.message || err);
  }
}
